module.exports = __webpack_public_path__ + "img/Man.fdad8074.svg";